/**
 * Created by JIocb on 20.06.2017.
 */

namespace Factive.Game {
    import Signal = Factive.Core.Signal.Signal;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import InteractionEvent = PIXI.interaction.InteractionEvent;
    import ISoundManager = Factive.Core.ISoundManager;
    // import LocalizationManager = Arkadium.Core.utils.LocalizationManager;

    export class ScoreTableRowView  {
        private _view:PIXI.Container;
        private  _title:PIXI.Text;
        private  _x1:PIXI.Text;
        private  _x2:PIXI.Text;
        private  _x3:PIXI.Text;
        private _dc: DependenciesContainer;
        private _lm: LocalizationManager;
        private _btnX1: DragonBonesButton;
        private _btnX2: DragonBonesButton;
        private _btnX3: DragonBonesButton;
        private _frozenSelection:Array<dragonBones.Armature> = [];
        private _enableInputForced:boolean = true;

        
        public signal: Signal = new Signal();
        private _armature: dragonBones.Armature;
        private _data: any;
        private _hintBtn: dragonBones.IArmatureDisplay|any;
        private _assetScale: number;

        constructor(armature:dragonBones.Armature,dc:DependenciesContainer) {
            
            this._armature = armature;
            this._view = <PIXI.Container>armature.display;
            this._dc = dc;
            this._lm = this._dc.get("LocalizationManager");
            this._assetScale = this._dc.get("AssetScale");
            
            this.build();
        }

        public get x():number{return this._view.x;};
        public get y():number{return this._view.y}
        public get width():number{return this._view.width;}
        public get height():number{return this._view.height;}

        private _score_style: PIXI.TextStyle;
        private _score_zero_style: PIXI.TextStyle;

        private build():void
        {
            this._score_style = <PIXI.TextStyle>{
                fontFamily: 'Bold',
                fontSize: 16* this._assetScale,
                fill: '#FFFFFF',
                align: "center"
            };

            this._score_zero_style = <PIXI.TextStyle>{
                fontFamily: 'Bold',
                fontSize: 16* this._assetScale,
                fill: '#257181',
                align: "center"
            };

            this._title = new PIXI.Text("", <PIXI.TextStyle>{
                fontFamily: 'Regular',
                fontSize: 14* this._assetScale,
                fill: '#FFFFFF',
                align: "left"
            });
            this._title.anchor.set(0,.5);

            //this._title.scale.x = this._title.scale.y = .5;

            this._x1 = new PIXI.Text("", this._score_style);
            this._x1.anchor.set(.5,.5);
            //this._x1.scale.x = this._x1.scale.y = .5;

            this._x2 = new PIXI.Text("", this._score_style);
            this._x2.anchor.set(.5,.5);
            //this._x2.scale.x = this._x2.scale.y = .5;

            this._x3 = new PIXI.Text("", this._score_style);
            this._x3.anchor.set(.5,.5);
            //this._x3.scale.x = this._x3.scale.y = .5;

            this._view.addChild(this._title);
            this._view.addChild(this._x1);
            this._view.addChild(this._x2);
            this._view.addChild(this._x3);

            this._title.x = -this._view.width*.45;
            this._title.y = -this._view.height*.37;


            this._x1.x = this._view.width*.085;
            this._x1.y = -this._view.height*.37;

            this._x2.x = this._view.width*.26;
            this._x2.y = -this._view.height*.37;

            this._x3.x = this._view.width*.43;
            this._x3.y = -this._view.height*.37;


            this._btnX1 = new DragonBonesButton(this._armature.getSlot("ScoreTableBtnScore0").childArmature,this._dc);
            this._btnX1.addPressListener(this.handlePressX1, this);

            this._btnX2 = new DragonBonesButton(this._armature.getSlot("ScoreTableBtnScore1").childArmature,this._dc);
            this._btnX2.addPressListener(this.handlePressX2, this);

            this._btnX3 = new DragonBonesButton(this._armature.getSlot("ScoreTableBtnScore2").childArmature,this._dc);
            this._btnX3.addPressListener(this.handlePressX3, this);

            this._frozenSelection[0] = this._armature.getSlot("ResultTableRowPainting0").childArmature;
            this._frozenSelection[0].animation.play("draw", 1);
            this._frozenSelection[0].animation.stop();
            this._frozenSelection[0].display.visible = false;

            this._frozenSelection[1] = this._armature.getSlot("ResultTableRowPainting1").childArmature;
            this._frozenSelection[1].animation.play("draw", 1);
            this._frozenSelection[1].animation.stop();
            this._frozenSelection[1].display.visible = false;

            this._frozenSelection[2] = this._armature.getSlot("ResultTableRowPainting2").childArmature;
            this._frozenSelection[2].animation.play("draw", 1);
            this._frozenSelection[2].animation.stop();
            this._frozenSelection[2].display.visible = false;

            this._hintBtn = this._armature.getSlot("bac_tab").display;
            this._hintBtn.interactive = true;
            this._hintBtn.buttonMode = true;

            this._hintBtn.addListener("pointerover",this.handleHintBtnEvent,this);
            this._hintBtn.addListener("pointerdown",this.handleHintBtnEvent,this);
            this._hintBtn.addListener("mouseover",this.handleHintBtnEvent,this);
            this._hintBtn.addListener("pointerout",this.handleHintBtnEvent,this);
            this._hintBtn.addListener("pointerup",this.handleHintBtnEvent,this);
            this._hintBtn.addListener("mouseout",this.handleHintBtnEvent,this);

        }

        private handleHintBtnEvent(evt:InteractionEvent )
        {
            switch(evt.type)
            {
                case "pointerdown":
                case "mouseover":
                case "pointerover":{ this.signal.dispatch("showHint",{id:this._data.id,multiplier:1}); break;}
                case "mouseout":
                case "pointerup":
                case "pointerout":{this.signal.dispatch("hideHint",{id:this._data.id,multiplier:1});break;}
            }

        };

        private handlePressX1(evt:string):void
        {
            this.signal.dispatch("press",{id:this._data.id,multiplier:1});
        }

        private handlePressX2(evt:string):void
        {
            this.signal.dispatch("press",{id:this._data.id,multiplier:2});
        }

        private handlePressX3(evt:string):void
        {
            this.signal.dispatch("press",{id:this._data.id,multiplier:3});
        }

        private setScoreStyle(label: PIXI.Text){
            if(label.text == "0" && label.style != this._score_zero_style){
                label.style = this._score_zero_style;
            }else if (label.style != this._score_style) {
                label.style = this._score_style;
            }
        }

        public setData(data:any):void
        {
            this._data = data;
            let str: string = ScoreCombinationType[data.id];
            this._title.text = this._lm.getText(str.toLowerCase());
            if(this._title.width > this._hintBtn.width - 10*this._assetScale){
                this._title.width = this._hintBtn.width - 10*this._assetScale;
            }

            this._x1.text = data.x1.value;
            this.setScoreStyle(this._x1);
            this._x2.text = data.x2.value;
            this.setScoreStyle(this._x2);
            this._x3.text = data.x3.value;
            this.setScoreStyle(this._x3);

            for(let i = 0; i < 3; i++)
            {
                let index:number = i + 1;
                let freeze: boolean = data["x" + index].freeze == true;
                if(this._frozenSelection[i].display.visible != freeze){
                    this["_btnX" + index].enableInput(!freeze && this._enableInputForced);
                    this._frozenSelection[i].display.visible = freeze;

                    if(freeze != true)
                    {
                        this["_btnX" + index].addPressListener(this["handlePressX" + index], this);
                        this._frozenSelection[i].animation.gotoAndStopByFrame("draw", 0);
                    }
                    else
                    {
                        this["_btnX" + index].removePressListener(this["handlePressX" + index], this);
                        this._frozenSelection[i].animation.play("draw", 1);

                        let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
                        sm.playSound(SoundConstants.SCRIBBLE);
                    }
                }
            }


            // let x2Freeze: boolean = data.x2.freeze == true;
            // this._frozenSelection[1].visible = x2Freeze;
            // this._btnX2.enableInput(!x2Freeze && this._enableInputForced);
            //
            // this._btnX2.removePressListener(this.handlePressX2, this);
            // if(x2Freeze != true)
            // {
            //     this._btnX2.addPressListener(this.handlePressX2, this);
            // }
            //
            // let x3Freeze: boolean = data.x3.freeze == true;
            // this._frozenSelection[2].visible = x3Freeze;
            // this._btnX3.enableInput(!x3Freeze && this._enableInputForced);
            //
            // this._btnX3.removePressListener(this.handlePressX3, this);
            // if(x3Freeze != true)
            // {
            //     this._btnX3.addPressListener(this.handlePressX3, this);
            // }

        };

        public enableInput(value:boolean):void
        {
            this._enableInputForced = value;

            this._btnX1.enableInput(value);
            this._btnX2.enableInput(value);
            this._btnX3.enableInput(value);
        }

        public destroy():void
        {
            this._hintBtn.interactive = false;
            this._hintBtn.buttonMode = false;

            this._hintBtn.removeListener("pointerover",this.handleHintBtnEvent,this);
            this._hintBtn.removeListener("pointerdown",this.handleHintBtnEvent,this);
            this._hintBtn.removeListener("mouseover",this.handleHintBtnEvent,this);
            this._hintBtn.removeListener("pointerout",this.handleHintBtnEvent,this);
            this._hintBtn.removeListener("pointerup",this.handleHintBtnEvent,this);
            this._hintBtn.removeListener("mouseout",this.handleHintBtnEvent,this);

            this._hintBtn = null;

            this._view.removeChild(this._title);
            this._title = null;

            this._view.removeChild(this._x1);
            this._x1 = null;

            this._view.removeChild(this._x2);
            this._x2 = null;

            this._view.removeChild(this._x3);
            this._x3 = null;
            this._view = null;
            this._dc = null;

            this._lm = null;

            this.signal.removeAll();

            this.signal = null;
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/ScoreTableRowView.ts